
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchWishlist } from '../../../../redux/actions/wishlistActions'
import { Add_To_Fav, Get_Product_List, Product_List_Data } from '../../../../api/category_product/Category_Product'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Loader from '../../../../loader/Loader'
import Footer from '../../../common/footer/Footer'
import Header from '../../../common/header/Header'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { toast } from 'react-toastify'
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { Helmet } from 'react-helmet'
import { get_Page_Seo } from '../../../../api/global/Global'
import parse from 'html-react-parser';

const Home_View_All_Product = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [pageSeo, set_Page_Seo] = useState({})

    const { gemstone_product, category_id } = location.state || {};
    const subcategory_id = gemstone_product && gemstone_product[0]?.sub_id
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const [is_loading, set_set_Is_Loading] = useState(false)
    const [products, setProducts] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12; // Show 12 products per page
    const [is_Open_Origin, set_Is_Open_Origin] = useState(false);
    const [is_Open_Shape, set_Is_Open_Shape] = useState(false);
    const [is_Open_Color, set_Is_Open_Color] = useState(false);
    const [is_Open_treatment, set_Is_Open_treatment] = useState(false);
    const [is_Open_Cut, set_Is_Open_Cut] = useState(false);
    const [is_Open_Certificate, set_Is_Open_Certificate] = useState(false);
    const [is_Open_Composition, set_Is_Open_Composition] = useState(false);
    const [selectedOrigins, setSelectedOrigins] = useState([]);
    const [selectedShape, setSelectedShape] = useState([]);
    const [selectedColor, setSelectedColor] = useState([]);
    const [selectedTreatment, setSelectedTreatment] = useState([]);
    const [selectedCut, setSelectedCut] = useState([]);
    const [selectedCertificate, setSelectedCertificate] = useState([]);
    const [selectedComposition, setSelectedComposition] = useState([]);

    const [minPrice, setMinPrice] = useState("0");
    const [maxPrice, setMaxPrice] = useState("");
    const [show_video, set_show_video] = useState(false)

    const [is_Open_price, set_Is_Open_price] = useState(false);
    const [price, setPrice] = useState([0, 100000]);

    const [is_Open_filter, set_Is_Open_filter] = useState(false);

    const [video, set_video] = useState("https://rasatva.parasmesoft.in/omens/public/uploads/product/videos/19056.mp4")
    const originRef = useRef(null);
    const shapeRef = useRef(null);
    const certificateRef = useRef(null);
    const cutRef = useRef(null);
    const colorRef = useRef(null);
    const compositionRef = useRef(null);
    const treatmentRef = useRef(null);
    const priceRef = useRef(null);

    const handlePlay_Video = (video_url) => {
        set_video(`${IMG_BASE_URL}${video_url}`)
        set_show_video(true)
    }

    const handleMinChange = (e) => {
        const newMin = Number(e.target.value);
        // Prevent min > max
        if (newMin <= price[1]) {
            setPrice([newMin, price[1]]);
        }
    };

    const handleMaxChange = (e) => {
        const newMax = Number(e.target.value);
        // Prevent max < min
        if (newMax >= price[0]) {
            setPrice([price[0], newMax]);
        }
    };


    useEffect(() => {
        setSelectedOrigins([])
        setSelectedTreatment([])
        setSelectedComposition([])
        setSelectedColor([])
        setSelectedCertificate([])
        setSelectedCut([])
        setSelectedShape([])
        setMaxPrice("")
        setMinPrice("0")

        set_Is_Open_price(false)
        set_Is_Open_treatment(false)
        set_Is_Open_Composition(false)
        set_Is_Open_Color(false)
        set_Is_Open_Cut(false)
        set_Is_Open_Certificate(false)
        set_Is_Open_Shape(false)
        set_Is_Open_Origin(false)


    }, [category_id, subcategory_id])

    const handleClickOutside = (event) => {

        if (originRef.current && !originRef.current.contains(event.target)) {
            set_Is_Open_Origin(false);

        }
        if (shapeRef.current && !shapeRef.current.contains(event.target)) {
            set_Is_Open_Shape(false);

        }
        if (certificateRef.current && !certificateRef.current.contains(event.target)) {
            set_Is_Open_Certificate(false);

        }
        if (cutRef.current && !cutRef.current.contains(event.target)) {
            set_Is_Open_Cut(false);

        }
        if (colorRef.current && !colorRef.current.contains(event.target)) {
            set_Is_Open_Color(false);

        }
        if (compositionRef.current && !compositionRef.current.contains(event.target)) {
            set_Is_Open_Composition(false);

        }
        if (treatmentRef.current && !treatmentRef.current.contains(event.target)) {
            set_Is_Open_treatment(false);

        }
        if (priceRef.current && !priceRef.current.contains(event.target)) {
            set_Is_Open_price(false);

        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        };
    }, []);
    // Calculate total pages safely
    const totalPages = Math.ceil(products?.product?.length / productsPerPage) || 1;

    // Windowed page numbers for responsive display
    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = products?.product?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const toggle_origin_accordion = () => {
        set_Is_Open_Origin(!is_Open_Origin);
    };

    const toggle_Shape_accordion = () => {
        set_Is_Open_Shape(!is_Open_Shape);
    };

    const toggle_Cut_accordion = () => {
        set_Is_Open_Cut(!is_Open_Cut);
    };

    const toggle_Certificate_accordion = () => {
        set_Is_Open_Certificate(!is_Open_Certificate);
    };

    const toggle_color_accordion = () => {
        set_Is_Open_Color(!is_Open_Color);
    };

    const toggle_composition_accordion = () => {
        set_Is_Open_Composition(!is_Open_Composition);
    };

    const toggle_treatment_accordion = () => {
        set_Is_Open_treatment(!is_Open_treatment);
    };

    const toggle_treatment_price = () => {
        set_Is_Open_price(!is_Open_price);
    };

    // <------------ handle origin Checkbox Change ----------->
    const handle_origin_Checkbox_Change = (originName) => {
        setSelectedOrigins((prevSelected) =>
            prevSelected?.includes(originName)
                ? prevSelected?.filter((name) => name !== originName)
                : [...prevSelected, originName]
        );
        set_Is_Open_Origin(false)
    };
    // Comma-separated list of selected IDs
    const selectedOriginsString = selectedOrigins.join(',');

    // <------------ handle Certifiate Checkbox Change ----------->
    const handle_certificate_Checkbox_Change = (CertificateName) => {
        setSelectedCertificate((prevSelected) =>
            prevSelected?.includes(CertificateName)
                ? prevSelected?.filter((name) => name !== CertificateName)
                : [...prevSelected, CertificateName]
        );
        set_Is_Open_Certificate(false)
    };
    const selectedCertificateString = selectedCertificate.join(',');

    // <------------ handle Shape Checkbox Change ----------->
    const handle_shape_Checkbox_Change = (ShapeName) => {
        setSelectedShape((prevSelected) =>
            prevSelected?.includes(ShapeName)
                ? prevSelected?.filter((name) => name !== ShapeName)
                : [...prevSelected, ShapeName]
        );
        set_Is_Open_Shape(false)
    };
    const selectedShapeString = selectedShape.join(',');

    // <------------ handle Cut Checkbox Change ----------->

    const handle_cut_Checkbox_Change = (CutName) => {
        setSelectedCut((prevSelected) =>
            prevSelected?.includes(CutName)
                ? prevSelected?.filter((name) => name !== CutName)
                : [...prevSelected, CutName]
        );
        set_Is_Open_Cut(false)
    };
    const selectedCutString = selectedCut.join(',');

    // <------------ handle Shape Checkbox Change ----------->
    const handle_color_Checkbox_Change = (ColorName) => {
        setSelectedColor((prevSelected) =>
            prevSelected?.includes(ColorName)
                ? prevSelected?.filter((name) => name !== ColorName)
                : [...prevSelected, ColorName]
        );
        set_Is_Open_Color(false)
    };
    const selectedColorString = selectedColor.join(',');

    // <------------ handle Composition Checkbox Change ----------->
    const handle_composition_Checkbox_Change = (CompositionName) => {
        setSelectedComposition((prevSelected) =>
            prevSelected?.includes(CompositionName)
                ? prevSelected?.filter((name) => name !== CompositionName)
                : [...prevSelected, CompositionName]
        );
        set_Is_Open_Composition(false)
    };
    const selectedCompositionString = selectedComposition.join(',');

    // <------------ handle Shape Checkbox Change ----------->
    const handle_treatment_Checkbox_Change = (treatmentName) => {
        setSelectedTreatment((prevSelected) =>
            prevSelected?.includes(treatmentName)
                ? prevSelected?.filter((name) => name !== treatmentName)
                : [...prevSelected, treatmentName]
        );
        set_Is_Open_treatment(false)
    };
    const selectedTreatmentString = selectedTreatment.join(',');

    // Handle changes to price inputs
    const handlePriceChange = (type, value) => {
        const price = Math.max(0, Math.min(100000, Number(value)));
        if (type === "min") setMinPrice(Math.min(price, maxPrice));
        if (type === "max") setMaxPrice(Math.max(price, minPrice));
    };

    // <--------- Add To Favorite --------->
    const Handle_add_to_favorite = async (id, cat_id, sub_id) => {
        const data = {
            cat_id: cat_id,
            subcat_id: sub_id,
            product_id: id
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast.error("User not login here")
                throw new Error("User token not found");
            }
            if (!Get_user_is_active) {
                toast.error("User not login here")
                return
            }
            const response = await Add_To_Fav(data, { Authorization: `Bearer ${token}` })
            if (response?.status == "200") {
                toast.success(response?.data?.message)
                setProducts((prev) => {
                    const updatedProducts = prev?.product?.map((product) =>
                        product?.id === id
                            ? { ...product, is_favourite: !product?.is_favourite }
                            : product
                    );
                    return {
                        ...prev,
                        product: updatedProducts,
                    };
                });
                dispatch(fetchWishlist());
            }
            else if (response?.response?.data?.status == "500") {
                // handle silently
            }
        }
        catch (error) {
            console.error("error", error)
        }
    }

    const Handle_Get_Product_List = async () => {
        set_set_Is_Loading(true);

        const productPayload = {
            category_id,
            subcategory_id,
            is_best: "1",
            origin_id: selectedOriginsString,
            shape_id: selectedShapeString,
            cut_id: selectedCutString,
            certificate_id: selectedCertificateString,
            color_id: selectedColorString,
            composition_id: selectedCompositionString,
            treatment_id: selectedTreatmentString,
            min_amount: minPrice,
            max_amount: maxPrice,
        };

        try {
            let response;

            if (Get_user_is_active) {
                const token = User_Authentication();

                if (!token) {
                    response = await Product_List_Data(productPayload);
                    setProducts(response?.data?.data);
                    return;
                }

                response = await Get_Product_List(productPayload, {
                    Authorization: `Bearer ${token}`,
                });

                if (response?.data?.status == 200) {
                    setProducts(response?.data?.data);
                } else if (response?.response?.data?.status == 401) {
                    // toast.error("Session expired. Showing public data.");
                    localStorage.removeItem("user_token");
                    localStorage.removeItem("user_is_active");

                    const publicResponse = await Product_List_Data(productPayload);
                    setProducts(publicResponse?.data?.data);
                } else {
                    const publicResponse = await Product_List_Data(productPayload);
                    setProducts(publicResponse?.data?.data);
                }
            } else {
                const response = await Product_List_Data(productPayload);
                setProducts(response?.data?.data);
            }
        } catch (error) {
            console.error("Error in Handle_Get_Product_List:", error);
            // toast.error("Failed to load products");
        } finally {
            set_set_Is_Loading(false);
        }
    };


    useEffect(() => {
        Handle_Get_Product_List();
    }, [Get_user_is_active, category_id, subcategory_id, selectedOriginsString, selectedShapeString, selectedCutString, selectedCertificateString, selectedColorString, selectedCompositionString, selectedTreatmentString, minPrice, maxPrice]);

    // <---------------------seo data fetch-------------->
    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Best Selling Products")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_set_Is_Loading(false);
            }
        }
        Get_Page_Seo()
    }, [])

    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}all-best-selling-product`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}all-best-selling-product`} />

            </Helmet>
            {/* <--------- Header section's ------> */}
            <Header />
            {/* <-------- ToastContainer ------------> */}
            {/* <ToastContainer style={{ marginTop: "120px" }} /> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        {/* <----------- Category_Main_Banner section's------> */}
                        <section className='banner-section mb-4'>
                            <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                } className='w-full h-[150px] sm:h-[220px] md:h-[300px] object-cover' />

                            </div>
                        </section>
                        {/* <Category_Main_Banner data={gemstone_product} /> */}
                        <section className="gi-category py-[40px] max-[767px]:py-[0px] overflow-x-hidden">
                            <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="">
                                    {/* <!-- Sidebar Area Start --> */}
                                    <div className="gi-shop-sidebar">
                                        <div id="shop_sidebar">
                                            <div className="gi-sidebar-wrap grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                                                {/* <!-- Sidebar Category Block --> */}
                                                <div ref={originRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <div className="text-red-700 text-lg flex justify-between items-center cursor-pointer">
                                                            {/* <span><i className="fi-rr-filter mr-2"></i> Filter</span> */}
                                                            <span className={`transform transition-transform ${is_Open_Origin ? "rotate-180" : ""}`}></span>
                                                        </div>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_origin_accordion}>Origin  <i class={`gicon gi-angle-down ${is_Open_Origin && 'rotate-180'}`}></i>
                                                        </h3>
                                                    </div>
                                                    {/* Accordion Content */}
                                                    {is_Open_Origin && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:right-0">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.origin?.map((origin_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedOrigins.includes(origin_result?.id)}
                                                                                        onChange={() => handle_origin_Checkbox_Change(origin_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{origin_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedOrigins.includes(origin_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* <!-- Sidebar Shape Block --> */}
                                                <div ref={shapeRef} className="gi-sidebar-block relative ">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Shape ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_Shape_accordion}>Shape <i class={`gicon gi-angle-down ${is_Open_Shape && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Shape && (
                                                        <div className="gi-sb-block-content absolute top-12 right-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:left-0">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.shape?.map((shape_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedShape.includes(shape_result?.id)}
                                                                                        onChange={() => handle_shape_Checkbox_Change(shape_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{shape_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedOrigins.includes(shape_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }

                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar Cut Block --> */}
                                                <div ref={cutRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Cut ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_Cut_accordion}>Cut <i class={`gicon gi-angle-down ${is_Open_Cut && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Cut && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:right-0">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.cut?.map((cut_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedCut.includes(cut_result?.id)}
                                                                                        onChange={() => handle_cut_Checkbox_Change(cut_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{cut_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedCut.includes(cut_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar Certificate Block --> */}
                                                <div ref={certificateRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Certificate ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_Certificate_accordion}>Certificate <i class={`gicon gi-angle-down ${is_Open_Certificate && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Certificate && (
                                                        <div className="gi-sb-block-content absolute top-12 right-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:left-0">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.certificate
                                                                        ?.map((certificate_result) => {
                                                                            return (
                                                                                <li>
                                                                                    <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                            checked={selectedCertificate.includes(certificate_result?.id)}
                                                                                            onChange={() => handle_certificate_Checkbox_Change(certificate_result?.id)}
                                                                                        />
                                                                                        <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                            <span className="flex">{certificate_result?.name}</span>
                                                                                        </p>
                                                                                        <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedCertificate.includes(certificate_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar Color item --> */}
                                                <div ref={colorRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Color ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_color_accordion}>Color <i class={`gicon gi-angle-down ${is_Open_Color && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Color && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:right-0">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.color?.map((color_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedColor.includes(color_result?.id)}
                                                                                        onChange={() => handle_color_Checkbox_Change(color_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{color_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedColor.includes(color_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar composition item --> */}

                                                <div className="gi-sidebar-block relative" onClick={() => set_Is_Open_filter(!is_Open_filter)}>
                                                    <div className={`gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee] ${is_Open_filter ? 'bg-[#e3e3e3]' : 'bg-white'} `}>
                                                        <span className={`transform transition-transform "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]">{is_Open_filter ? 'Less Filters' : 'More Filters'} {is_Open_filter ? <i class="gicon fi-rr-minus"></i> : <i class="gicon fi-rr-plus"></i>}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {is_Open_filter && (
                                                <div className="gi-sidebar-wrap grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mt-3">
                                                    <div ref={compositionRef} className="gi-sidebar-block relative">
                                                        <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                            <span className={`transform transition-transform ${is_Open_Composition ? "rotate-180" : ""}`}></span>
                                                            <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                                                                flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_composition_accordion}>Composition <i class={`gicon gi-angle-down ${is_Open_Composition && 'rotate-180'}`}></i></h3>
                                                        </div>
                                                        {is_Open_Composition && (
                                                            <div className="gi-sb-block-content absolute top-12 left-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:right-0">
                                                                <ul>
                                                                    {
                                                                        products?.filter_by?.composition
                                                                            ?.map((composition_result) => {
                                                                                return (
                                                                                    <li>
                                                                                        <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                                checked={selectedComposition.includes(composition_result?.id)}
                                                                                                onChange={() => handle_composition_Checkbox_Change(composition_result?.id)}
                                                                                            />
                                                                                            <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                                <span className="flex">{composition_result?.name}</span>
                                                                                            </p>
                                                                                            <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedComposition.includes(composition_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                        </div>
                                                                                    </li>
                                                                                )
                                                                            })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* <!-- Sidebar Composition item --> */}
                                                    <div ref={treatmentRef} className="gi-sidebar-block relative">
                                                        <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                            <span className={`transform transition-transform ${is_Open_treatment ? "rotate-180" : ""}`}></span>
                                                            <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                                                                flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_treatment_accordion}>Treatment <i class={`gicon gi-angle-down ${is_Open_treatment && 'rotate-180'}`}></i></h3>
                                                        </div>
                                                        {is_Open_treatment && (
                                                            <div className="gi-sb-block-content absolute top-12 right-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:left-0">
                                                                <ul>
                                                                    {
                                                                        products?.filter_by?.treatment?.map((treatment_result) => {
                                                                            return (
                                                                                <li>
                                                                                    <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                            checked={selectedTreatment.includes(treatment_result?.id)}
                                                                                            onChange={() => handle_treatment_Checkbox_Change(treatment_result?.id)}
                                                                                        />
                                                                                        <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                            <span className="flex">{treatment_result?.name}</span>
                                                                                        </p>
                                                                                        <span
                                                                                            className={`checked absolute top-1/2 left-0 h-4 w-4  border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedTreatment.includes(treatment_result?.id) ? "bg-red-500 border-red-500" : ""
                                                                                                }`}
                                                                                        />
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* <!-- Sidebar Price Block --> */}

                                                    <div ref={priceRef} className="gi-sidebar-block relative">
                                                        <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                            <span className={`transform transition-transform ${is_Open_price ? "rotate-180" : ""}`}></span>
                                                            <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                                                                flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_treatment_price}>Filter By Price <i class={`gicon gi-angle-down ${is_Open_price && "rotate-180"}`}></i></h3>
                                                        </div>
                                                        {is_Open_price && (
                                                            <div className="gi-sb-block-content absolute top-12 left-0 z-20 bg-white border border-t-0 px-3 w-[240px] sm:w-[280px] lg:w-full lg:right-0">
                                                                <div className="gi-price-filter flex flex-col">
                                                                    <div className="gi-price-input mt-4 mb-3">

                                                                        <div className="flex pricefilter items-center relative">
                                                                            <RangeSlider min={0}
                                                                                max={100000} value={price} onInput={setPrice} className={"range-slider__range range-slider__thumb"} />
                                                                        </div>
                                                                        <div className="pricefilter flex justify-between text-gray-600 text-[10px] mt-4">
                                                                            <span>Min:</span>
                                                                            <span>Max:</span>
                                                                        </div>
                                                                        <div className='pricefilter flex justify-between gap-3 text-[10px] w-full'>
                                                                            <input type="number" value={JSON.parse(price[0])} className='w-[50%] border border-gray-400 text-center rounded-md ' onChange={handleMinChange} />
                                                                            <input type="number" value={JSON.parse(price[1])} className='w-[50%] border border-gray-400 text-center rounded-md ' onChange={handleMaxChange} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {/* <!-- Sidebar Area End --> */}
                                    <div className="gi-shop-rightside mt-4 md:mt-0">
                                        {/* <!-- Shop Top Start --> */}
                                        <div className="gi-pro-list-top flex items-center justify-between text-[13px] border-b border-gray-200 pb-3 mb-6 mt-4 md:mt-8">
                                            <div className="w-full gi-grid-list">
                                                <h1 className="text-xl text-gray-900 font-semibold">List of All Best Selling Products</h1>
                                            </div>
                                        </div>
                                        {/* <!-- Shop Top End --> */}

                                        {/* <!-- Shop content Start --> */}
                                        {
                                            currentProduct?.length > 0 ? (
                                                <div className="shop-pro-content">
                                                    <div className="shop-pro-inner">
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-5 w-full">
                                                            {
                                                                currentProduct?.map((product_list_result) => {
                                                                    const isOutOfStock = product_list_result?.current_stock <= 0; // Check stock status
                                                                    return (
                                                                        <div className={`pro-gl-content ${isOutOfStock ? "opacity-50 pointer-events-none" : ""}`}>
                                                                            <div className="gi-product-content h-full">
                                                                                <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out  overflow-hidden rounded-[5px] shadow-custome">
                                                                                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                                                                                        <div className="gi-pro-image overflow-hidden">
                                                                                            {
                                                                                                product_list_result?.is_favourite === true ? (
                                                                                                    <span className="flags flex flex-col bg-white h-7 w-7 sm:h-8 sm:w-8 items-center justify-center border rounded-full hover:bg-gray-200 cursor-pointer uppercase absolute top-[5px] right-[5px] xs:right-[15px] z-[2]">
                                                                                                        <img className="main-image w-[14px] h-[14px] sm:w-[18px] sm:h-[18px] transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                            src={Common_Images_Transport?.wish_list} alt="Product"
                                                                                                            onClick={() => Handle_add_to_favorite(product_list_result?.id, product_list_result?.cat_id, product_list_result?.sub_id)} />
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <span className="flags flex flex-col bg-white h-7 w-7 sm:h-8 sm:w-8 items-center justify-center border rounded-full hover:bg-gray-200 cursor-pointer uppercase absolute top-[5px] right-[5px] xs:right-[15px] z-[2]">
                                                                                                        <i onClick={() => Handle_add_to_favorite(product_list_result?.id, product_list_result?.cat_id, product_list_result?.sub_id)}
                                                                                                            className="fi-rr-heart transition-all text-[12px] sm:text-[15px] duration-[0.3s]  ease-in-out text-[#777] leading-[10px]"></i>
                                                                                                    </span>
                                                                                                )
                                                                                            }

                                                                                            {
                                                                                                product_list_result?.product_images?.find(img => img.file_type == "video") && (
                                                                                                    <span onClick={() => handlePlay_Video(
                                                                                                        product_list_result?.product_images?.find(img => img.file_type === "video")?.video_url
                                                                                                    )} className="flags flex flex-col h-7 w-7 sm:h-8 sm:w-8 bg-white items-center justify-center border rounded-full hover:bg-gray-200 cursor-pointer uppercase absolute top-[5px] right-[40px] xs:right-[60px] z-[2]">
                                                                                                        <i
                                                                                                            className="fi-rr-play transition-all text-[12px] sm:text-[15px] duration-[0.3s] ease-in-out text-[#777] leading-[10px]"></i>
                                                                                                    </span>
                                                                                                )
                                                                                            }
                                                                                            <a href="#" className="image productimg7 h-[160px] xs:h-[180px] sm:h-[220px] md:h-[250px] relative block overflow-hidden pointer-events-none">
                                                                                                {(() => {
                                                                                                    const imageList = product_list_result?.product_images
                                                                                                        ?.filter(item => item.file_type === 'image')
                                                                                                        ?.slice(0, 2); // Get only first 2 images

                                                                                                    return (
                                                                                                        <>
                                                                                                            <img
                                                                                                                className="first_pro main-image object-cover h-[160px] xs:h-[180px] sm:h-[220px] md:h-[250px] transition-all duration-[0.3s] ease delay-[0s] "
                                                                                                                src={`${IMG_BASE_URL}${imageList[0]?.image_url}`}
                                                                                                                alt={product_list_result?.alt_image_title || 'Product Image'}
                                                                                                            />
                                                                                                            <img
                                                                                                                className="first_pro_hover main-image object-cover h-[160px] xs:h-[180px] sm:h-[220px] md:h-[250px] transition-all duration-[0.3s] ease delay-[0s]  "
                                                                                                                src={`${IMG_BASE_URL}${imageList[1]?.image_url || imageList[0]?.image_url}`}
                                                                                                                alt={product_list_result?.alt_image_title || 'Product Image'}
                                                                                                            />
                                                                                                        </>
                                                                                                    );
                                                                                                })()}
                                                                                            </a>

                                                                                            {isOutOfStock && (
                                                                                                <div className="absolute top-2 left-2 bg-red-600 text-white text-[9px] xs:text-[10px] sm:text-xs px-1.5 py-0.5 sm:px-2 sm:py-1 rounded">
                                                                                                    Out of Stock
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {/* product videos */}
                                                                                    {
                                                                                        show_video == true && (
                                                                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/10 backdrop-blur-[2px]">
                                                                                                <div className='relative'>
                                                                                                    {/* Close Button */}
                                                                                                    <button
                                                                                                        onClick={() => set_show_video(false)}
                                                                                                        className="absolute -top-6 -right-6 text-white bg-black bg-opacity-60 rounded-full w-8 h-8 flex items-center justify-center text-xl hover:bg-opacity-80 z-30"
                                                                                                    >
                                                                                                        &times;
                                                                                                    </button>

                                                                                                    {/* Video Modal */}
                                                                                                    <div className="w-full max-w-[500px] h-auto rounded-lg overflow-hidden shadow-lg relative">
                                                                                                        <video
                                                                                                            autoPlay
                                                                                                            loop
                                                                                                            muted
                                                                                                            controls
                                                                                                            className="w-full h-full object-cover"
                                                                                                        >
                                                                                                            <source src={video} type="video/mp4" />
                                                                                                        </video>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className="gi-pro-content h-full p-3 xs:p-4 sm:p-5 md:p-[30px] pt-[0] relative z-[10] flex flex-col text-center">
                                                                                        <h5 className="gi-pro-stitle mt-2 sm:mt-4 text-gray-800 uppercase text-[11px] xs:text-[12px] sm:text-[13px] md:text-[14px] font-semibold leading-[1.2] truncate">
                                                                                            {product_list_result?.name}
                                                                                        </h5>
                                                                                        <div className="flex flex-col justify-center items-center">
                                                                                            <div className="flex gap-1.5 xs:gap-2 items-center mb-1.5 sm:mb-3">
                                                                                                <span className="new-price text-gray-700 font-semibold text-[11px] xs:text-[12px] sm:text-[13px]">
                                                                                                    Rs.{product_list_result?.seller_price}
                                                                                                </span>

                                                                                                {product_list_result?.discount && (
                                                                                                    <span className="new-price text-gray-500 font-normal text-[10px] xs:text-[11px] sm:text-[12px] line-through">
                                                                                                        Rs.{product_list_result?.purchase_price}
                                                                                                    </span>
                                                                                                )}

                                                                                            </div>
                                                                                            <button onClick={() => {
                                                                                                if (!isOutOfStock) {
                                                                                                    navigate(`/product/${product_list_result?.slug
                                                                                                        }`)
                                                                                                }
                                                                                            }}
                                                                                                type="button"
                                                                                                className={`text-[9px] xs:text-[10px] sm:text-[11px] md:text-[12px] uppercase border border-gray-200 text-gray-900 font-semibold px-2 py-1.5 sm:px-3 sm:py-2 rounded hover:bg-gray-300 transition-colors w-full ${isOutOfStock ? "cursor-not-allowed" : ""
                                                                                                    }`} disabled={isOutOfStock}>
                                                                                                {isOutOfStock ? "Not Available" : "View More"}
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            }

                                                        </div>
                                                    </div>
                                                    {/* <!-- Pagination Start --> */}
                                                    <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                        <span className="text-[13px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, products?.product?.length)} of {products?.product?.length} items</span>
                                                        <ul className="gi-pro-pagination-inner flex flex-wrap gap-1">
                                                            {currentPage > 1 && (
                                                                <li>
                                                                    <button
                                                                        onClick={handlePrev}
                                                                        className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                                                    >
                                                                        Prev
                                                                    </button>
                                                                </li>
                                                            )}
                                                            {getPaginationItems().map((page, index) => {
                                                                if (page === '...') {
                                                                    return (
                                                                        <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                                            <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                                                ...
                                                                            </span>
                                                                        </li>
                                                                    );
                                                                }
                                                                return (
                                                                    <li key={page} className="inline-block float-left">
                                                                        <button
                                                                            onClick={() => handlePageChange(page)}
                                                                            className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                                                text-[#777] bg-[#eee] px-2
                                                                                text-[14px] rounded
                                                                                ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                                        >
                                                                            {page}
                                                                        </button>
                                                                    </li>
                                                                );
                                                            })}
                                                            {currentPage < totalPages && (
                                                                <li>
                                                                    <button
                                                                        onClick={handleNext}
                                                                        className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                                                    >
                                                                        Next
                                                                    </button>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>

                                                </div>
                                            ) : (
                                                <div className="w-full flex flex-col items-center justify-center text-center py-16 px-6 bg-white rounded-2xl border border-gray-100 shadow-sm max-w-md mx-auto my-8 animate-fadeIn">
                                                    <style>{`
                                                      @keyframes fadeIn {
                                                        from { opacity: 0; transform: translateY(10px); }
                                                        to { opacity: 1; transform: translateY(0); }
                                                      }
                                                      .animate-fadeIn {
                                                        animation: fadeIn 0.3s ease-out forwards;
                                                      }
                                                    `}</style>
                                                    <img
                                                        src={Common_Images_Transport?.emptyCart}
                                                        alt="No products available"
                                                        className="w-40 h-40 object-contain mb-6"
                                                    />
                                                    <h3 className="text-lg font-bold text-gray-950 mb-1.5">No Products Found</h3>
                                                    <p className="text-gray-500 text-xs sm:text-sm max-w-xs leading-relaxed">
                                                        Products are not available at the moment. Please check back later or try exploring another category.
                                                    </p>
                                                </div>
                                            )
                                        }
                                        <div className="sub__title custome_viewbox text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/*  */}
                        <Footer />
                    </>
                )
            }
        </>
    )
}

export default Home_View_All_Product